module.exports = __webpack_public_path__ + "static/media/mongodb-og.56b6467a.svg";